export default class AppInfoDefine {
  static readonly APP_NAME = 'Amazon4Sellers'
  static readonly APP_VERSION = '1.0.0'
  static readonly APP_VERSION_TAG = 1
  static readonly APP_ORG_NAME = 'LemonIT.CN'
}
